module.exports = __webpack_public_path__ + "static/media/whatsapp.fbb3f491.svg";